export const REPORTING_QUERY_KEYS = {
  all: ["REPORTING"] as const,
  kpis: () => [...REPORTING_QUERY_KEYS.all, "KPIS"] as const,
  finance: () => [...REPORTING_QUERY_KEYS.all, "FINANCE"] as const,
  projects: () => [...REPORTING_QUERY_KEYS.all, "PROJECTS"] as const,
  actors: () => [...REPORTING_QUERY_KEYS.all, "ACTORS"] as const,
  partners: () => [...REPORTING_QUERY_KEYS.all, "PARTNERS"] as const,
  generations: () => [...REPORTING_QUERY_KEYS.all, "GENERATIONS"] as const,
} as const;
